<span [class]="hostClasses">
  <span class="pay-chip__label">{{ label }}</span>
  <button
    *ngIf="removable"
    type="button"
    class="pay-chip__remove"
    (click)="onRemove($event)"
    aria-label="Remove">
    <lucide-icon name="x" [size]="10"></lucide-icon>
  </button>
</span>
